import React from "react";
import PropTypes from "prop-types";

const HapimagLogo = ({classname, onClick}) => {

    return (
        <img
            alt="Hapimag Logo"
            src="/images/hapimag-logo2.svg"
            className={classname}
            onClick={onClick}
        />
    );
};

HapimagLogo.propTypes = {
    classname: PropTypes.string,
    onClick: PropTypes.func,
};

export default HapimagLogo;
